module.exports = __webpack_public_path__ + "img/order-icon.b4dcd858.webp";